import { s } from "@kosmod/pancake";
import { ID, idDef } from "@kosmod/kit";

import { TheatrePosition, theatrePositionDef } from "./position";
import { AnyLogicState } from "./logic/all";
import { GameID } from "@kosmod/sesame";

export const miniAnimationDef = s.ref<MiniAnimation>()(s.o({
  start: s.num,
  points: s.a(theatrePositionDef),
}))
export const MiniAnimation = miniAnimationDef;

export const miniDef = s.ref<Mini>()(s.o({
  id: idDef,

  // model: s.str,

  position: theatrePositionDef,
  rotation: s.num,

  animation: miniAnimationDef,
  networkState: s.lu(['ok', 'pending']),

  logic: s.a(AnyLogicState),

  type: s.lu(['character', 'monster', 'door', 'visibility-source'])
}));
export const Mini = miniDef;

export type MiniID = ID<"mini", true>;
export const MiniID = idDef;
export type Mini = {
  id: MiniID,

  // model: string,

  position: TheatrePosition,
  rotation: number,
  animation: null | MiniAnimation,

  logic: AnyLogicState[],

  networkState: 'ok' | 'pending'
}

export type MiniEvent =
  | { type: 'move', position: TheatrePosition, animation: null | MiniAnimation }
  // | { type: 'model', model: string }
  | { type: 'logic', index: number, state: AnyLogicState }

export type PlaceMini = {
  model: string,
  position: TheatrePosition,
  logic: AnyLogicState[],
}

export const MiniEvent = s.du('type', {
  move: { position: theatrePositionDef, animation: s.optional(miniAnimationDef) },
  // model: { model: s.str },
  logic: { index: s.num, state: AnyLogicState }
})

export const MiniEvents = {
  Move: (position: TheatrePosition, animation: null | MiniAnimation): MiniEvent => ({
    type: 'move',
    position,
    animation
  }),
  Logic: (index: number, state: AnyLogicState): MiniEvent => ({
    type: 'logic',
    state,
    index
  }),
}

export type MiniAnimation = {
  start: number,

  points: TheatrePosition[]
}

export const updateMini = (mini: Mini, event: MiniEvent): Mini => {
  switch (event.type) {
    // case 'model':
    //   return { ...mini, model: event.model };
    case 'move':
      return { ...mini, animation: event.animation, position: event.position }
    case 'logic':
      return { ...mini, logic: mini.logic.map((l, i) => i === event.index ? event.state : l)}
  }
}

/**
 * Since a Mini is a literal thing in a scene, a MiniTemplate
 * is all the data stored in a game to create instances of that mini.
 */
export type MiniTemplate = {
  id: MiniTemplateID,
  game: GameID,

  name: string,
  logic: AnyLogicState[],
}
export type MiniTemplateID = ID<"mini-template">;
export const MiniTemplateID = s.ref<MiniTemplateID>()(idDef);
export const MiniTemplate = s.ref<MiniTemplate>()(s.o({
  id: MiniTemplateID,
  game: GameID,

  name: s.str,
  logic: s.a(AnyLogicState)
}))